/**
 * Template registry — maps template keys to components and metadata.
 */

import type { TemplateKey, ShareFormat, CarouselSlideRole } from '../ShareTarget';
import { TemplateT1 } from './TemplateT1';
import { TemplateT2 } from './TemplateT2';
import { TemplateStoryT3 } from './TemplateStoryT3';
import { CarouselSlide1 } from './carousel/CarouselSlide1';
import { CarouselSlide2 } from './carousel/CarouselSlide2';
import { CarouselSlide3 } from './carousel/CarouselSlide3';
import type { ShareCardProps } from './ShareCardBase';
import type { ComponentType } from 'react';

export interface TemplateEntry {
  key: TemplateKey;
  label: string;
  description: string;
  component: ComponentType<ShareCardProps>;
  /** Formats this template supports */
  formats: ShareFormat[];
}

export const TEMPLATES: TemplateEntry[] = [
  {
    key: 't1',
    label: 'Hero',
    description: 'Bildfokus med gradient',
    component: TemplateT1,
    formats: ['ig-post', 'ig-story', 'fb'],
  },
  {
    key: 't2',
    label: 'Klassisk',
    description: 'Centrerad titel, ren design',
    component: TemplateT2,
    formats: ['ig-post', 'ig-story', 'fb'],
  },
  {
    key: 't3',
    label: 'Story',
    description: 'Stor titel, minimal',
    component: TemplateStoryT3,
    formats: ['ig-story'],
  },
];

export function getTemplate(key: TemplateKey): TemplateEntry | undefined {
  return TEMPLATES.find((t) => t.key === key);
}

export function getTemplatesForFormat(format: ShareFormat): TemplateEntry[] {
  return TEMPLATES.filter((t) => t.formats.includes(format));
}

/** Carousel slide components in order: hook → info → cta */
export interface CarouselSlideEntry {
  index: number;
  role: CarouselSlideRole;
  component: ComponentType<ShareCardProps>;
}

export const CAROUSEL_SLIDES: CarouselSlideEntry[] = [
  { index: 0, role: 'hook', component: CarouselSlide1 },
  { index: 1, role: 'info', component: CarouselSlide2 },
  { index: 2, role: 'cta', component: CarouselSlide3 },
];
